import { render, staticRenderFns } from "./heziShop2.vue?vue&type=template&id=6c662585&scoped=true&"
import script from "./heziShop2.vue?vue&type=script&lang=js&"
export * from "./heziShop2.vue?vue&type=script&lang=js&"
import style0 from "./heziShop2.vue?vue&type=style&index=0&id=6c662585&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c662585",
  null
  
)

export default component.exports